import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase";
import Modal from "../../components/admin/FormModal";
import Input from "../../components/admin/Input";
import styles from "./AdminPTLTeam.module.css";
import Layout from "../../components/admin/Layout";
import AdminList from "../../components/admin/AdminList";
import IconTextButton from "../../components/admin/IconTextButton";
import { Helmet } from "react-helmet";

function AdminTeam() {
  const [teams, setTeams] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingTeam, setEditingTeam] = useState(null);
  const [form, setForm] = useState({
    name: "",
    age: "",
    level: "",
    win_avg: null,
    goal_avg: null,
    goal_against_avg: null,
    win_draw_lose: null,
  });

  const fetchTeams = async () => {
    const { data, error } = await supabase.from("team").select("*");
    if (!error) setTeams(data);
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  const openModal = (team = null) => {
    setEditingTeam(team);
    setForm(
      team || {
        name: "",
        age: "",
        level: "",
        win_avg: null,
        goal_avg: null,
        goal_against_avg: null,
        win_draw_lose: null,
      }
    );
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingTeam(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    // 빈 문자열을 null로 변환
    const preparedForm = {
      ...form,
      win_avg: form.win_avg === "" ? null : parseFloat(form.win_avg),
      goal_avg: form.goal_avg === "" ? null : parseFloat(form.goal_avg),
      goal_against_avg:
        form.goal_against_avg === "" ? null : parseFloat(form.goal_against_avg),
    };
  
    try {
      if (editingTeam) {
        // 업데이트
        const { error } = await supabase
          .from("team")
          .update(preparedForm)
          .eq("id", editingTeam.id);
        if (error) {
          console.error("Error updating team:", error);
          return;
        }
      } else {
        // 삽입
        const { error } = await supabase.from("team").insert([preparedForm]);
        if (error) {
          console.error("Error adding team:", error);
          return;
        }
      }
  
      await fetchTeams();
      closeModal();
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  };

  

  const headers = [
    { label: "이름", key: "name" },
    { label: "나이", key: "age" },
    { label: "레벨", key: "level" },
    { label: "승률", key: "win_avg" },
    { label: "평균 득점", key: "goal_avg" },
    { label: "평균 실점", key: "goal_against_avg" },
    { label: "승무패", key: "win_draw_lose" },
  ];

  return (
    <Layout>
      <Helmet>
        <title>어드민:팀</title>
      </Helmet>
    <div className={styles.toolBar}>
      <IconTextButton
        icon="icon_plus_square.svg"
        text="추가하기"
        onClick={() => openModal()}
        state="Enabled"
      />
    </div>
        <AdminList
          data={teams}
          headers={headers}
          onRowClick={openModal} // 행 클릭 시 모달 열기
        />

        {/* 모달 */}
        <Modal
          title={editingTeam ? "팀 수정" : "팀 추가"}
          isOpen={isModalOpen}
          onClose={closeModal}
          onSubmit={handleSubmit}
        >
          {/* Input 컴포넌트 활용 */}
          <Input
            label="이름"
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="이름"
            required
          />
          <Input
            label="나이"
            type="number"
            name="age"
            value={form.age}
            onChange={handleChange}
            placeholder="나이"
            required
          />
          <Input
            label="레벨"
            type="text"
            name="level"
            value={form.level}
            onChange={handleChange}
            placeholder="레벨"
            required
          />
          <Input
            label="승률"
            type="number"
            name="win_avg"
            value={form.win_avg}
            onChange={handleChange}
            placeholder="승률"
            required
          />
          <Input
            label="승무패"
            type="text"
            name="win_draw_lose"
            value={form.win_draw_lose}
            onChange={handleChange}
            placeholder="승무패"
            required
          />
          <Input
            label="평균 득점"
            type="number"
            name="goal_avg"
            value={form.goal_avg}
            onChange={handleChange}
            placeholder="평균 득점"
            required
          />
          <Input
            label="평균 실점"
            type="number"
            name="goal_against_avg"
            value={form.goal_against_avg}
            onChange={handleChange}
            placeholder="평균 실점"
            required
          />
        </Modal>
    </Layout>
  );
}

export default AdminTeam;